import {z} from '@hono/zod-openapi';

export const VoiceDebugWebRtcOfferResponseSchema = z
  .object({
    schemaVersion: z.literal('1.0.0'),
    sdpAnswer: z
      .string()
      .min(1)
      .max(64 * 1024)
      .refine((value) => new TextEncoder().encode(value).byteLength <= 64 * 1024),
    state: z.literal('connecting'),
  })
  .strict()
  .openapi('VoiceDebugWebRtcOfferResponseSchema');

export type VoiceDebugWebRtcOfferResponse = z.infer<typeof VoiceDebugWebRtcOfferResponseSchema>;
